<template>
  <v-row class="mt-1">
    <slot> </slot>
    <v-col class="pt-0">
      <div class="float-right">
        <div>
          <v-btn
            v-if="addButton"
            variant="flat"
            :disabled="disabled"
            class="float-right ml-2"
            size="x-small"
            @click="$emit('add')"
            color="primary"
            width="60px"
          >
            <v-icon left size="small" class="mr-0"> mdi-plus </v-icon>
            Add
          </v-btn>
          <v-btn
            v-if="saveButton"
            variant="flat"
            :loading="loadingSave"
            color="primary"
            size="x-small"
            class="float-right"
            :disabled="disabled"
            @click="$emit('save')"
          >
            Save
            <template v-slot:loader>
              <v-progress-circular indeterminate size="12" width="2"> </v-progress-circular>
            </template>
          </v-btn>
        </div>
        <div class="float-right btn-container mt-2">
          <v-btn
            v-if="downloadButton"
            color="primary"
            size="x-small"
            variant="outlined"
            :prepend-icon="downloadIcon"
            :disabled="disabled"
            @click="$emit('download')"
          >
            {{ downloadText }}
          </v-btn>
          <v-btn
            v-if="exportButton"
            color="primary"
            size="x-small"
            variant="outlined"
            :prepend-icon="exportIcon"
            :disabled="disabled"
            @click="$emit('export')"
          >
            {{ exportText }}
          </v-btn>
          <v-btn
            v-if="importButton"
            color="primary"
            size="x-small"
            variant="outlined"
            :prepend-icon="importIcon"
            :disabled="disabled"
            @click="$emit('import')"
          >
            {{ importText }}
          </v-btn>
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'TitleAlertSaveImport',
  props: {
    unSavedChanges: { required: false },
    disabled: { required: false, default: false },
    loadingSave: { required: false, default: false },
    importButton: { required: false, default: true },
    downloadButton: { required: false, default: false },
    importIcon: { required: false, default: 'mdi-upload' },
    downloadIcon: { required: false, default: 'mdi-download' },
    exportIcon: { required: false, default: 'mdi-export' },
    exportText: { required: false, default: 'Export' },
    downloadText: { required: false, default: 'Download' },
    importText: { required: false, default: 'Import' },
    exportButton: { required: false, default: false },
    saveButton: { required: false, default: true },
    addButton: { required: false, default: true }
  }
}
</script>
